import { ReviewActionsProps } from "../types";
import { Button, TextField, Stack, Divider } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { TextInput } from "qubCommon/Inputs";

const ReviewActions = (props: ReviewActionsProps) => {
    const { onApprove, onReject } = props;
    const methods = useForm();

    const handleReject = () => {
        // handle submit reject
        onReject("reason");
    };

    return (
        <FormProvider {...methods}>
            <Stack direction="column" spacing={2} sx={{ width: "100%" }}>
                <Divider sx={{ borderWidth: 1 }} />
                <TextInput
                    name="validationComments"
                    label="Validation Comments"
                    multiline
                    rows={3}
                />
                <Stack
                    direction="row"
                    spacing={1}
                    sx={{ width: "100%" }}
                    justifyContent="flex-end"
                >
                    <Button
                        onClick={onApprove}
                        variant="contained"
                        sx={{
                            background: "#4d79bc",
                            color: "#fff",
                            ":hover": {
                                background: "#79AEC9",
                                color: "#fff",
                            },
                        }}
                    >
                        Approve
                    </Button>
                    <Button
                        onClick={handleReject}
                        variant="contained"
                        sx={{
                            background: "#c42c0e",
                            color: "#fff",
                            ":hover": {
                                background: "#c9807d",
                                color: "#fff",
                            },
                        }}
                    >
                        Reject
                    </Button>
                </Stack>
            </Stack>
        </FormProvider>
    );
};

export default ReviewActions;
